import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";

const WHATSAPP_URL = "https://wa.me/33660235665";

export const FloatingWhatsapp = () => (
  <motion.a
    href={WHATSAPP_URL}
    target="_blank"
    rel="noopener noreferrer"
    initial={{ opacity: 0, scale: 0 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ delay: 1.6, type: "spring", stiffness: 200 }}
    whileHover={{ scale: 1.1 }}
    className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-[#25D366] border-2 border-black flex items-center justify-center shadow-[4px_4px_0px_#121212]"
    data-testid="floating-whatsapp"
  >
    <MessageCircle className="w-6 h-6 text-white fill-white" />
  </motion.a>
);
